export default function Footer() {
  return (
    <footer className="relative bg-primary-800 text-foreground-50">
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{
          background: 'linear-gradient(to right, transparent, rgba(189,1,1,0.6), transparent)',
        }}
      />
      <div className="max-w-full px-4 md:px-8 py-7 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/40">
        <span>&copy; {new Date().getFullYear()} 华东交通大学 版权所有</span>
        <span>技术支持：华东交通大学信息化中心</span>
      </div>
    </footer>
  );
}